(ns frontend.view.reports.custom.alj-2.active-deals-per-bu-and-deal-type-table
  (:require
   [clojure.set :as set]
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.reports.custom.alj :as alj]
   [frontend.view.reports.custom.alj-2.alj-components :as alj-components]
   [frontend.view.reports.custom.alj-2.utils :as alj-utils]
   [reagent.core :as r]))

(defn row-data
  [top-deal-types deals-wo-active-dea-type? active-deal-type-ids count-others? oppos label]
  (concat [label
           (count oppos)]
          (->> top-deal-types
               (map (fn [deal-type]
                      (let [deal-type-id-match #{(:db/id deal-type)}]
                        (->> oppos
                             (filter (fn [oppo]
                                       (some deal-type-id-match (:oppo/tag-deal-type oppo))))
                             (count)))))
               (doall))
          (when count-others?
            [(->> oppos
                  (filter (fn [oppo]
                            (not-empty (set/difference (set (:oppo/tag-deal-type oppo)) top-deal-types))))
                  (count))])
          (when deals-wo-active-dea-type?
            [(->> oppos
                  (filter (fn [oppo]
                            (empty? (set/difference (set (:oppo/tag-deal-type oppo)) active-deal-type-ids))))
                  (count))])))

(defn report
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{:entity.type/oppo} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [active-deals (->> (alj/all-deals)
                              (cu/filter-by :oppo/status :oppo.status/ok)
                              (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo))
            used-deal-types (->> active-deals
                                 (mapcat :oppo/tag-deal-type)
                                 (frequencies)
                                 (sort-by second)
                                 (keep (fn [[eid nof]]
                                         (let [entity (get @session/entities eid)]
                                           (when-not (:common/disabled? entity)
                                             entity))))
                                 (doall))
            active-deal-type-ids (->> (session/non-archived-named-values :oppo/tag-deal-type (alj/alj-report-pipeline-id))
                                      (map :db/id)
                                      (set))
            deals-wo-active-dea-type? (->> active-deals
                                           (some (fn [oppo]
                                                   (empty? (set/difference (set (:oppo/tag-deal-type oppo)) active-deal-type-ids)))))
            top-deal-types (->> used-deal-types
                                (take 4))
            count-others? (> (count used-deal-types) 4)
            active-business-units (session/non-archived-named-values :oppo/group-business-units (alj/alj-report-pipeline-id))
            active-business-unit-ids (->> active-business-units
                                          (map :db/id)
                                          (set))
            oppos-by-business-unit (->> active-deals
                                        (mapcat (fn [oppo]
                                                  (->> oppo
                                                       :oppo/group-business-units
                                                       (map (fn [bu-id]
                                                              [bu-id oppo])))))
                                        (group-by first)
                                        (map (fn [[bu-id bu-id-oppos]]
                                               [bu-id
                                                (->> bu-id-oppos
                                                     (map second)
                                                     (doall))]))
                                        (into {}))
            business-units-deals-data (->> active-business-units
                                           (map (fn [bu]
                                                  (let [bu-oppos (get oppos-by-business-unit (:db/id bu))]
                                                    (row-data top-deal-types
                                                              deals-wo-active-dea-type?
                                                              active-deal-type-ids
                                                              count-others?
                                                              bu-oppos
                                                              (entity/display-string bu)))))
                                           (sort-by second)
                                           (reverse))
            oppos-without-active-bu (->> active-deals
                                         (remove (fn [oppo]
                                                   (some active-business-unit-ids (:oppo/group-business-units oppo)))))
            no-active-bu-data (when (seq oppos-without-active-bu)
                                (row-data top-deal-types
                                          deals-wo-active-dea-type?
                                          active-deal-type-ids
                                          count-others?
                                          oppos-without-active-bu
                                          (loc/tr :oppos-without-active-group-business-unit)))
            duplicate-bus (->> active-deals
                               (filter (fn [oppo]
                                         (> (count (:oppo/group-business-units oppo)) 1))))
            duplicate-bus-data (when (seq duplicate-bus)
                                 (row-data top-deal-types
                                           deals-wo-active-dea-type?
                                           active-deal-type-ids
                                           count-others?
                                           duplicate-bus
                                           (loc/tr :oppos-with-duplicate-business-units)))]
        [alj-components/alj-card
         {:view-name       (loc/tr :active-deals-per-business-unit-and-deal-type)
          :report-data     business-units-deals-data
          :date-state-atom date-state-atom
          :view            [:table.alj-report.zap-simple-table
                            [:thead
                             [:tr
                              [:th "SBU"]
                              [:th (loc/tr :total-number-of-deals)]
                              (->> top-deal-types
                                   (map-indexed (fn [idx deal-type]
                                                  ^{:key (str "alj-2-active-deals-per-bu-and-deal-type-" idx)}
                                                  [:th (fu/resolve-name deal-type)]))
                                   (doall))
                              (when count-others?
                                [:th (loc/tr :other)])
                              (when deals-wo-active-dea-type?
                                [:th (loc/tr :no-deal-type)])]]
                            [:tbody
                             (->> business-units-deals-data
                                  (map-indexed (fn [idx row-data]
                                                 ^{:key (str "alj-2-active-deals-per-bu-and-deal-type-bu-" idx)}
                                                 [:tr
                                                  {:class-name "alj-data-row"}
                                                  (->> row-data
                                                       (map-indexed (fn [cell-idx cell-data]
                                                                      (let [no-data? (= 0 cell-data)]
                                                                        ^{:key (str "alj-2-active-deals-per-bu-and-deal-type-bu-" idx "-" cell-idx)}
                                                                        [:td
                                                                         {:class-name (fu/cs (when-not (= cell-idx 0)
                                                                                               "number-cell")
                                                                                             (when no-data?
                                                                                               "empty-cell")
                                                                                             (when (= cell-idx 1)
                                                                                               "highlight-cell"))}
                                                                         (if no-data?
                                                                           "-"
                                                                           (str cell-data))])))
                                                       (doall))]))
                                  (doall))]
                            [:tfoot
                             [:tr.alj-totals-row
                              (->>
                               (row-data top-deal-types deals-wo-active-dea-type? active-deal-type-ids count-others? active-deals (loc/tr :grand-total))
                               (map-indexed (fn [cell-idx cell-data]
                                              ^{:key (str "alj-2-active-deals-per-bu-and-deal-type-totals" cell-idx)}
                                              [:td
                                               {:class-name (fu/cs (when-not (= cell-idx 0)
                                                                     "number-cell"))}
                                               (str cell-data)]))
                               (doall))]
                             (when no-active-bu-data        ;; What does customer want to do with this?
                               [:tr.alj-error-row
                                (->> no-active-bu-data
                                     (map-indexed (fn [cell-idx cell-data]
                                                    ^{:key (str "alj-2-active-deals-per-bu-and-deal-type-unknown-bus-" cell-idx)}
                                                    [:td
                                                     {:class-name (fu/cs (when-not (= cell-idx 0)
                                                                           "number-cell"))}
                                                     (str cell-data)]))
                                     (doall))])
                             (when duplicate-bus-data       ;; What does customer want to do with this?
                               [:tr.alj-duplicate-row
                                (->> duplicate-bus-data
                                     (map-indexed (fn [cell-idx cell-data]
                                                    ^{:key (str "alj-2-active-deals-per-bu-and-deal-type-duplicate-bus-" cell-idx)}
                                                    [:td
                                                     {:class-name (fu/cs (when-not (= cell-idx 0)
                                                                           "number-cell"))}
                                                     (str cell-data)]))
                                     (doall))])]]}]))))
